import pluralize from 'pluralize';

export default (value, amount) => pluralize(value.toString(), amount);
